import { init, withScope, captureException } from '@sentry/react';
import env from '@frontend/env';
import { SentryTeamNames } from '@frontend/sentry-teams';

type Environment = 'test' | 'preview' | 'production' | 'debug';

const initialize = () => {
  // Set the Sentry environment based on the Vite environment variables
  let environment: Environment = 'test';
  if (env.IS_PREVIEW === 'true') {
    environment = 'preview';
  } else if (import.meta.env.MODE === 'production') {
    environment = 'production';
  }

  return init({
    dsn: env.SENTRY_DSN,
    // IMPORTANT: This has to match what we have for our source maps in reusable-build-and-deploy.yml
    release: env.VERSION,
    environment,
    integrations: [],
    sampleRate: import.meta.env.MODE === 'production' ? 0.25 : 0,
    tracesSampleRate: import.meta.env.MODE === 'production' ? 0.01 : 0,
  });
};

export const error = ({
  error,
  topic,
  team,
  severityLevel = 'error',
  addContext,
}: {
  error: unknown;
  topic: string;
  team: SentryTeamNames;
  severityLevel: 'error';
  addContext?: {
    name: string;
    context: Record<string, any>;
  };
}) => {
  withScope((scope) => {
    scope.setTag('topic', topic);
    scope.setTag('team', team);
    scope.setLevel(severityLevel);
    if (!!addContext) scope.setContext(addContext.name, addContext.context);
    captureException(error);
  });
};

const sentry: {
  initialize: () => ReturnType<typeof init>;
  error: typeof error;
} = {
  initialize,
  error,
};

export { sentry };
